<template>
    <div class="investment-box">
        <Title :title="detil.title" :url="`${domianURL}/${list.icoOne}`" />
        <div class="bg-petri">
            <img src="@/assets/image/petrifaction/bg-2.png" />
        </div>
        <div class="dooc" v-html="detil.details"></div>
        <Menu />
    </div>
</template>

<script>
import Menu from "@/components/menu.vue";
import Title from "@/components/title.vue";
import { getAction } from "@/api/manage.js";
export default {
    created() {
        this.loadata();
    },
    components: {
        Menu,
        Title,
    },
    data() {
        return {
            detil: {},
            list: {},
        };
    },
    methods: {
        loadata() {
            getAction("/rel/nl/queryByType", {
                type: this.$route.query.id,
            }).then((res) => {
                if (res.success) {
                    this.detil = res.result;
                }
            });
            getAction("/sys/category/queryById", {
                id: this.$route.query.id,
            }).then((res) => {
                if (res.success) {
                    this.list = res.result;
                }
            });
        },
    },
};
</script>

<style lang="scss">
.investment-box {
    .bg-petri {
        img {
            position: fixed;
            width: 100%;
            bottom: 0;
            left: 0;
            opacity: .6;
        }
    }
}
</style>
